import { registerMessages } from "../../../i18n/runtime";
import { inventoryEn } from "./messages.en";
import { inventoryEs } from "./messages.es";
registerMessages("en", inventoryEn);
registerMessages("es", inventoryEs);

import "./stock-costing-messages";
import "./stock-return-messages";
